/**
 * Object of possible Vendor Application Statuses
 */

const ApplicationStatus = {
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PENDING_ACCOUNTING_APPROVAL: 'PENDING_ACCOUNTING_APPROVAL',
  APPLICATION_PENDING: 'APPLICATION_PENDING',
  ARCHIVE: 'ARCHIVE',
};

export default ApplicationStatus;
